import WCCContentASCIIEmojiRule from '../asciiEmoji';
import WCCContentAttachmentsDummyRule from '../attachmentsDummy';
import WCCContentRule from '../base';
import WCCContentCardsSortRule from '../cardssort';
import WCCContentEmailRule from '../email';
import WCCContentEmojiRule from '../emoji';
import WCCContentImageRule from '../image';
import WCCContentLinkRule from '../link';
import WCCContentSmileyRemovalRule from '../smileyRemoval';
import WCCContentPhotosetRule from '../photoset';
import WCCContentSurveyImagesRule from '../surveyImages';
import WCCContentVimeoRule from '../vimeo';
import WCCContentYoutubeRule from '../youtube';
import WCCContentVideosRule from "../videos";
import WCCContentVideosDummyRule from "../videosDummy";

const wccContentForHighlightsRules = <Array<WCCContentRule>>[
    new WCCContentSurveyImagesRule(),
    new WCCContentAttachmentsDummyRule(),
    new WCCContentVideosDummyRule(),
    new WCCContentPhotosetRule(),
    new WCCContentCardsSortRule(),
];

export default wccContentForHighlightsRules;